import { Component } from '@theme/component';
import { formatMoney } from '@theme/money-formatting';

export class BundleForm extends Component {
  basePrice = 0;
  totalPrice = '0';
  inputName = '_aw_bundle_options';

  connectedCallback() {
    super.connectedCallback();
    this.init();
  }

  init() {
    this.basePrice = Number(this.dataset.basePrice);
    this.totalEl = this.querySelector('[data-total]');

    this.calculate();
    this.addEventListener('change', this.calculate);
  }

  calculate() {
    const { total } = this.getSelectedPrice(this);

    this.totalPrice = formatMoney(this.basePrice + total, Theme.format, Shopify.currency.active).replace('.00', '');

    if (this.totalEl) {
      this.totalEl.innerText = this.totalPrice;
    }

    this.querySelectorAll('[data-selected-price]').forEach(block => {
      const wrapper = block.closest('[x-data]');

      if (!wrapper) return;

      const type = wrapper.dataset.optionType;
      const { total, hasSelection } = this.getSelectedPrice(wrapper);

      this.updateHiddenInput(total, hasSelection);

      if (!hasSelection) {
        block.innerHTML = type === '0' || type === '3'
          ? '<span>Nothing is selected yet</span>'
          : '';

        return;
      }

      if (total === 0) {
        block.innerHTML = '';

        return;
      }

      const formatted = formatMoney(total, Theme.format, Shopify.currency.active).replace('.00', '');

      block.innerHTML = `<span class="font-semibold">+${ formatted }</span>`;
    });
  }

  getSelectedPrice(container) {
    let total = 0;
    let hasSelection = false;

    container.querySelectorAll('input:checked, option:checked').forEach(el => {
      const price = el.dataset.price ? parseInt(el.dataset.price || '0', 10) : NaN;

      if (!isNaN(price)) {
        total += price;
        hasSelection = true;
      }
    });

    return { total, hasSelection };
  }

  updateHiddenInput() {
    let input = this.querySelector(`input[name="properties[${ this.inputName }]"]`);

    const result = [];
    let hasAnySelection = false;

    this.querySelectorAll('[x-data]').forEach(wrapper => {
      const optionName = wrapper.dataset.optionName;

      if (!optionName) return;

      const selected = [];

      wrapper.querySelectorAll('input:checked, option:checked').forEach(el => {
        if (el.value) {
          selected.push(el.value);
        }
      });

      if (selected.length) {
        hasAnySelection = true;
        result.push(`${ optionName }:${ selected.join(',') }`);
      }
    });

    if (hasAnySelection) {
      if (!input) {
        input = document.createElement('input');

        input.type = 'hidden';
        input.name = `properties[${ this.inputName }]`;

        this.querySelector('form[action="/cart/add"]')?.appendChild(input);
      }

      input.value = result.join('/');
    } else {
      if (input) input.remove();
    }
  }

  validateRequiredOptions() {
    let isValid = true;
    let firstInvalid = null;

    this.querySelectorAll('[x-data]').forEach(wrapper => {
      const isRequired = wrapper.dataset.required ? true : false;

      if (!isRequired || !isValid) return;

      let hasSelection = false;

      wrapper.querySelectorAll('input, select').forEach(el => {
        if (el.tagName === 'SELECT') {
          if (el.multiple) {
            if ([...el.selectedOptions].length) {
              hasSelection = true;
            }
          } else {
            if (el.value) {
              hasSelection = true;
            }
          }
        } else if (el.type === 'radio' || el.type === 'checkbox') {
          if (el.checked) {
            hasSelection = true;
          }
        }
      });

      if (!hasSelection) {
        isValid = false;

        if (!firstInvalid) {
          firstInvalid = wrapper;
        }

        wrapper.classList.add('error');
      } else {
        wrapper.classList.remove('error');
      }
    });

    if (firstInvalid) {
      firstInvalid.scrollIntoViewIfNeeded();
    }

    return isValid;
  }
}

if (!customElements.get('bundle-form')) {
  customElements.define('bundle-form', BundleForm);
}
